import React from 'react';
import { Stack, Card, CardContent, Typography } from 'components/base';
import { BadgeOutlinedIcon } from 'assets/icons';
import PhoneInput from 'components/__v2__/PhoneInput';
import { Button } from 'components/atoms';
import { iconDiv } from '../../styles';
import { useQRStore } from '../../store/useQRStore';
import { useSendVerificationCode } from '../../hooks/useSendVerificationCode';

export const VerifyIdentity: React.FC = () => {
  const { mobileNumber, setMobileNumber } = useQRStore();
  const { handleSendVerificationCode, sendVerificationCodeLoading, error } =
    useSendVerificationCode();
  return (
    <Card raised sx={{ maxWidth: '80%' }}>
      <CardContent>
        <Stack p={2} spacing={2}>
          <Stack sx={iconDiv} bgcolor="primary.background">
            <BadgeOutlinedIcon fontSize="large" color="primary" />
          </Stack>
          <Typography variant="h5" color="text.primary" alignSelf="center">
            Verify Your Identity
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Please enter your mobile number to access the form.
            <br /> A verification code will be sent to this number.
          </Typography>
          <Stack gap={0.5}>
            <Typography variant="subtitle2">
              Mobile Number (e.g., +61XXXXXXXXX)
            </Typography>
            <PhoneInput
              placeholder="Enter your mobile number"
              value={mobileNumber}
              onChange={(value) => setMobileNumber(value)}
            />
            {error && (
              <Typography variant="caption" color="error">
                {error}
              </Typography>
            )}
          </Stack>
          <Button
            onClick={handleSendVerificationCode}
            isLoading={sendVerificationCodeLoading}
          >
            Send Verification Code
          </Button>
        </Stack>
      </CardContent>
    </Card>
  );
};
